import { Box } from "@mui/material";
import React from "react";

const ReportsSectionSeperator = () => {
    return (
        <Box
        sx={{
            width: '120%',
            height: '5px',
            backgroundColor: '#E7EAEE',
            m: '80px 0px',
            position: "relative",
            left: '-10%',
        }}
        ></Box>
    )
}

export default ReportsSectionSeperator;